import { GetProp, Tooltip, Upload, UploadFile, UploadProps, notification } from "antd";
import { upload } from "@/utils/file/upload";

import { FC, useState } from "react";
import { DeleteOutlined, LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { getFileUrl } from "apis/file";
import { useTranslation } from 'react-i18next';

type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

type IUpload = {
  onChange: (id: string) => void;
} & {
  fileId: string;
  uniChar?: string | null;
  avatarId?: string;
}

const PublicUpload:FC<IUpload> = (props) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [imgUrl, setImgUrl] = useState<string | undefined>(undefined)
  const [fileName, setFileName] = useState<string | undefined>(undefined)

  const onPreview = async (file: UploadFile) => {
    let src = file.url as string;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj as FileType);
        reader.onload = () => resolve(reader.result as string);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  const onChange: UploadProps['beforeUpload'] = (file) => {
    // const isAPK = file.type === 'application/vnd.android.package-archive'; 
    // if (!isAPK) {
    //   notification.error({ placement: 'top', message: '上传文件格式错误', description: '请上传apk文件' })
    //   return false;
    // }
    setLoading(true)
    upload({name: file.name, size: file.size, file})
      .then(uploadedFile => {
        props.onChange(uploadedFile?.id ?? '')
        setImgUrl(getFileUrl(uploadedFile?.id ?? ''))
        setFileName(uploadedFile?.name ?? '')
      })
      .finally(() => setLoading(false))
    return false;
  };

  const delFile = () => {
    setFileName(undefined)
    props.onChange('')
  }

  const uploadButton = (
    <button style={{ border: 0, background: 'none' }} type="button">
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );

  const apkPreviewList = (
    <div>
      <a>{fileName}</a>
      <Tooltip title={t('app.delApk')}>
        <DeleteOutlined onClick={delFile} style={{fontSize: 18,cursor: 'pointer', marginLeft:10}}/>
      </Tooltip>
    </div>
  )

  return (
    <>
      {!fileName && 
        <Upload
          listType="picture-card"
          className="avatar-uploader"
          onPreview={onPreview}
          beforeUpload={onChange}
          accept=".apk"
          showUploadList={false}
          style={{cursor: 'pointer'}}
        >
          {uploadButton}
        </Upload>
      }
      {fileName && apkPreviewList}
    </>
    
  )
}

export default PublicUpload;